<template>
  <div class="yoyo-container mx-auto min-h-screen pb-4 pb-[env(safe-area-inset-bottom)]" @click="handleClickOverlay">
    <!-- 导航栏 -->
    <navBar>
      <template #right>
        <img :src="cardSrc" class="w-5 h-5" alt="" @click="goToCart" />
        <span class="text-sm mr-4">({{ cartItems.length }})</span>
        <img :src="mineSrc" class="w-5 h-5" alt="" @click="goToMine" />
      </template>
      <template #navBottom>
        <!-- 搜索框 -->
        <div class="rounded flex items-center justify-center relative overflow-visible bg-[#f7fafc] py-2">
          <div
            class="md:w-2/5 w-5/7 min-h-12 rounded-full border border-gray-200 flex items-center justify-center pl-3 bg-white"
            @click.stop="handleSearch">
            <img :src="searchSrc" class="w-4 h-4 mr-3" alt="" />
            <img
                :src="imageBaseUrl + item"
                v-for="item in detailInfo.placeIconList"
                :key="item"
                :alt="detailInfo.place"
                class="w-5 h-4 mr-1" />
            <van-search
              :value="selectedRegion"
              @input="handleInput"
              class="flex-1 p-0 pl-2"
              :placeholder="$t('home.searchText')"
              @search="handleInputEnter" />
          </div>
        </div>
      </template>
    </navBar>

    <!-- 套餐和天数选择 -->
    <product-options :skus="detailInfo.packageList" ref="productOptions" @change="handleChange" :isZh="isZh" />
    <!-- 产品描述 -->
    <product-describe :detailInfo="detailInfo" :isZh="isZh" />
    <!-- 产品评价 -->
    <product-review :detailInfo="detailInfo" :reviews="reviews" />
    <!-- 占位符 -->
    <div class="h-16"></div>

    <!-- 底部操作栏 -->
    <div class="fixed z-50 h-14 bottom-0 left-0 right-0 pb-[env(safe-area-inset-bottom)] yoyo-container mx-auto">
      <div class="flex items-center space-x-6 w-full lg:mx-4 lg:w-[calc(100%-2rem)] bg-white border-t border-gray-200 py-3 pr-3 pl-5">
        <van-icon
          :name="detailInfo.favorite ? 'like' : 'like-o'"
          :color="detailInfo.favorite ? '#ff7a00' : '#999'"
          size="24"
          @click.stop="handleFavorite(item)" />
        <van-icon name="chat-o" size="24" class="text-gray-400" @click.stop="handleCustomService" />
        <div class="w-full flex items-center justify-end space-x-3">
          <van-button type="warning" round class="h-8 mr-2" color="#ff7a00" @click="addToCart">
            {{ $t("products.addToCart") }}
          </van-button>
          <van-button type="danger" round class="h-8" color="#ff7a00" @click="buyNowNew">{{ $t("products.buyNow") }}</van-button>
          <!-- <van-button type="danger" round class="h-8" color="#ff7a00" @click="buyNow">{{ $t("products.buyNow") }}</van-button> -->
        </div>
      </div>
    </div>

    <!-- 地区选择弹窗 -->
    <van-popup v-model="showRegionPicker" position="bottom" round class="yoyo-container left-1/2 -translate-x-1/2 bg-transparent">
      <div class="p-3 lg:mx-4 lg:w-[calc(100%-2rem)] bg-white rounded-t-xl">
        <h3 class="text-lg font-medium mb-4 text-center">{{ $t("products.selectRegion") }}</h3>
        <div class="space-y-2 max-h-80 overflow-y-auto">
          <div
            v-for="region in regions"
            :key="region.id"
            class="flex items-center p-3 cursor-pointer hover:bg-gray-50 rounded"
            @click="selectRegion(region)">
            <img :src="imageBaseUrl + item" v-for="item in region.placeIconList" :key="item" :alt="region.place" class="w-5 h-4 mr-3" />
            <span class="text-sm">{{ isZh ? region.place : region.placeEn }}</span>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showPlaceList"
      position="top"
      :class="['flex items-start justify-center yoyo-container home-popup', popupClass]"
      :style="popupVars">
      <div class="md:w-2/5 w-5/7 h-140 bg-white rounded-2xl overflow-y-auto border border-gray-200 p-4">
        <!-- 最近搜索 -->
        <div class="mb-6" v-if="recentSearches.length > 0">
          <h3 class="text-sm font-medium text-gray-600 mb-3">{{ $t("home.recentSearch") }}</h3>
          <div class="space-y-2">
            <div
              v-for="search in recentSearches"
              :key="search.id"
              class="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded"
              @click.stop="handleRecentSearch(search)">
              <img :src="imageBaseUrl + item" v-for="item in search.placeIconList" :key="item" :alt="search.place" class="w-5 h-4 mr-2" />
              <span class="text-sm">{{ isZh ? search.place : search.placeEn }}</span>
            </div>
          </div>
        </div>

        <!-- 热门推荐 -->
        <div>
          <h3 class="text-sm font-medium text-gray-600 mb-3">{{ $t("home.popularRecommend") }}</h3>
          <div class="space-y-3">
            <div
              v-for="destination in popularDestinations"
              :key="destination.id"
              class="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded"
              @click.stop="handleDestinationClick(destination)">
              <img
                :src="imageBaseUrl + item"
                v-for="item in destination.placeIconList"
                :key="item"
                :alt="destination.place"
                class="w-5 h-4 mr-1" />
              <span class="text-sm">{{ isZh ? destination.place : destination.placeEn }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup, Search, Toast } from "vant"
import ProductOptions from "@/components/products/Options.vue"
import ProductDescribe from "@/components/products/Describe.vue"
import ProductReview from "@/components/products/Review.vue"
import { getProductDetail, getPlaceList, cartAdd, getCartList, getProductReview } from "@/apis/shop"
import { addFavorite, removeFavorite } from "@/apis/favorite"
import { mapGetters } from "vuex"
import { debounce } from "@/utils/common"

export default {
  name: "ProductDetail",
  components: {
    "product-options": ProductOptions,
    "product-describe": ProductDescribe,
    "product-review": ProductReview,
    [Search.name]: Search,
    [Popup.name]: Popup,
  },
  data() {
    return {
      searchSrc: require("@/assets/images/search-icon.png"),
      cardSrc: require("@/assets/images/card-icon.png"),
      mineSrc: require("@/assets/images/mine-icon.png"),
      selectedRegion: "",
      selectedRegionEn: "",
      showRegionPicker: false,
      regions: [],
      detailInfo: {},
      cartItems: [],
      reviews: "",

      showPlaceList: false,
      popularDestinations: [],
      recentSearches: [],
      tabHeight: 0,
    }
  },
  computed: {
    ...mapGetters({
      isZh: "lang/isZh",
      isLoggedIn: "auth/isLoggedIn",
    }),
    imageBaseUrl() {
      return process.env.VUE_APP_IMAGE_URL
    },
    totalCount() {
      return this.cartItems.reduce((total, item) => total + item.count, 0)
    },
    popupVars() {
      return {
        "--popup-tab-height": `${this.tabHeight}px`,
      }
    },
    popupClass() {
      const baseClass = "top-[calc(7rem+var(--popup-tab-height,0px))] sm:top-[calc(7rem+var(--popup-tab-height,0px))]"
      const desktopClass = "md:top-[calc(8rem+var(--popup-tab-height,0px))] "
      return `${baseClass} ${desktopClass}`
    },
  },
  methods: {
    selectRegion(region) {
      console.log("region :>> ", region)
      this.selectedRegion = this.isZh ? region.place : region.placeEn
      this.selectedRegionEn = region.placeEn
      this.showRegionPicker = false
      this.showPlaceList = false
      if (this.detailInfo.id === region.id) {
        return
      }
      this.getProductDetail(region.id)
    },
    addToCart() {
      if (this.isLoggedIn) {
        const cartItem = this.filterSettleData()

        cartAdd({
          skuId: cartItem.sku,
          count: cartItem.count,
        })
          .then((res) => {
            this.loadCartData()
          })
          .catch((err) => {})
      } else {
        const cartItem = this.filterSettleData()

        // 从localStorage获取现有购物车数据
        let cartData = []
        const existingCart = localStorage.getItem("yoyotravel_cart")
        if (existingCart) {
          cartData = JSON.parse(existingCart)
        }

        // 检查是否已存在相同配置的商品
        const existingItemIndex = cartData.findIndex((item) => item.sku === cartItem.sku)
        if (existingItemIndex > -1) {
          // 如果存在，增加数量
          cartData[existingItemIndex].count += cartItem.count
        } else {
          // 如果不存在，添加新商品
          cartData.push(cartItem)
        }

        // 保存到localStorage
        localStorage.setItem("yoyotravel_cart", JSON.stringify(cartData))
        this.loadCartData()
        // 显示成功提示
        Toast.success(this.$t("products.addedToCart"))
        console.log("加入购物车", cartItem)
      }
    },
    buyNow() {
      const cartItem = this.filterSettleData()
      console.log("cartItem :>> ", cartItem)
      localStorage.setItem("yoyotravel_settleData", JSON.stringify([cartItem]))
      this.$router.push({ path: "/pay", query: { type: this.detailInfo.type } })
    },
    buyNowNew() {
      const cartItem = this.filterSettleData()
      console.log("cartItem :>> ", cartItem)
      localStorage.setItem("yoyotravel_settleData", JSON.stringify([cartItem]))
      this.$router.push({ path: "/pay-new", query: { type: this.detailInfo.type } })
    },
    filterSettleData() {
      const { currentSecondLevel, currentFirstLevel, quantity, currentPrice, currentMarketPrice, getSelectedText, getSelectedTextEn } =
        this.$refs.productOptions
      const sku = currentSecondLevel ? currentSecondLevel.id : currentFirstLevel.id
      // 构建购物车商品数据
      const cartItem = {
        id: Date.now(), // 使用时间戳作为唯一ID
        sku: sku,
        region: this.detailInfo.type + " " + this.selectedRegion,
        regionEn: this.detailInfo.type + " " + this.selectedRegionEn,
        selectedText: getSelectedText(),
        selectedTextEn: getSelectedTextEn(),
        day: currentSecondLevel ? currentSecondLevel.name : 0,
        count: quantity,
        price: currentPrice,
        marketPrice: currentMarketPrice,
        type: this.detailInfo.type,
        picUrl: process.env.VUE_APP_IMAGE_URL + this.detailInfo.picUrl,
      }
      return cartItem
    },
    goToCart() {
      this.$router.push({ path: "/cart", query: { from: "detail" } })
    },
    goToMine() {
      this.$router.push({ path: "/mine" })
    },
    async getProductDetail(id) {
      try {
        const res = await getProductDetail({ id })
        this.detailInfo = res.data
      } catch (error) {
        console.log("object :>> ", error)
      }
    },
    async getPlaceList(keyword) {
      try {
        const { type, id } = this.$route.query
        const res = await getPlaceList({ type, keyword: keyword || "" })
        this.popularDestinations = res.data || []
      } catch (error) {
        console.log("object :>> ", error)
      }
    },
    async handleFavorite() {
      try {
        if (this.detailInfo.favorite) {
          await removeFavorite({ spuId: this.detailInfo.id })
          this.detailInfo.favorite = false
        } else {
          await addFavorite({ spuId: this.detailInfo.id })
          this.detailInfo.favorite = true
        }
      } catch (error) {
        console.log("收藏操作失败 :>> ", error)
      }
    },

    loadCartData() {
      // console.log("this.isLoggedIn :>> ", this.isLoggedIn)
      if (this.isLoggedIn) {
        getCartList({ids: ''})
          .then((res) => {
            this.cartItems = res.data.list
          })
          .catch((err) => {})
      } else {
        // 从localStorage加载购物车数据
        const cartData = localStorage.getItem("yoyotravel_cart")
        if (cartData) {
          this.cartItems = JSON.parse(cartData)
        }
      }
    },
    async getProductReview(id) {
      try {
        const res = await getProductReview({ spuId: id })
        this.reviews = res.data.list
        // console.log('this.productReview :>> ', this.productReview);
      } catch (error) {
        console.log("object :>> ", error)
      }
    },
    handleChange() {},
    handleCustomService() {
      this.openInNewTab("https://wa.me/60143869383")
    },
    openInNewTab(url) {
      // 创建一个虚拟的 a 标签
      const link = document.createElement("a")
      link.href = url
      link.target = "_blank"
      link.rel = "noopener noreferrer"

      // 添加到 DOM 中（隐藏）
      link.style.display = "none"
      document.body.appendChild(link)

      // 触发点击事件
      link.click()

      // 移除元素
      document.body.removeChild(link)
    },
    handleRegionClick() {
      this.showRegionPicker = true
      if (!this.regions.length) {
        this.getPlaceList()
      }
    },
    // 处理目的地点击，保存到最近搜索
    handleDestinationClick(destination) {
      this.saveToRecentSearches(destination)
      this.selectRegion(destination)
    },
    // 处理最近搜索点击
    handleRecentSearch(search) {
      this.saveToRecentSearches(search)
      this.selectRegion(search)
    },
    // 保存到最近搜索（最多3条）
    saveToRecentSearches(destination) {
      const { type } = this.$route.query
      // 移除已存在的相同项目
      this.recentSearches = this.recentSearches.filter((item) => item.id !== destination.id)
      // 添加到开头
      this.recentSearches.unshift(destination)
      // 保持最多3条记录
      if (this.recentSearches.length > 3) {
        this.recentSearches = this.recentSearches.slice(0, 3)
      }
      // 保存到localStorage
      localStorage.setItem(`yoyotravel_recentSearches_${type}`, JSON.stringify(this.recentSearches))
    },
    // 从localStorage加载最近搜索
    loadRecentSearches() {
      const { type } = this.$route.query
      const saved = localStorage.getItem(`yoyotravel_recentSearches_${type}`)
      if (saved) {
        try {
          this.recentSearches = JSON.parse(saved)
          // console.log("this.recentSearches :>> ", this.recentSearches)
        } catch (e) {
          console.error("Failed to parse recent searches:", e)
          this.recentSearches = []
        }
      }
    },
    handleSearch() {
      if (!this.popularDestinations.length) {
        this.getPlaceList()
      }
      this.showPlaceList = true
    },
    handleInput(val) {
      console.log("val :>> ", val)
      this.selectedRegion = val
      this.debouncedCheckRegister(this.selectedRegion)
    },
    handleClickOverlay() {
      console.log("handleClickOverlay")
      this.showPlaceList = false
      this.getPlaceList("")
      this.selectedRegion = this.isZh ? this.detailInfo.place : this.detailInfo.placeEn || ""
      this.selectedRegionEn = this.detailInfo.placeEn || ""
    },
    handleInputEnter() {
      this.getPlaceList(this.selectedRegion)
    },
  },
  created() {
    console.log("this.$route.query :>> ", this.$route.query, this.isZh)
    this.getProductDetail(this.$route.query.id)
    // this.getProductReview(this.$route.query.id)
    this.getPlaceList() // 加载地区列表
    this.selectedRegion = this.$route.query.place || ""
    this.selectedRegionEn = this.$route.query.placeEn || ""

    this.loadCartData() // 加载购物车数据
    this.loadRecentSearches() // 加载最近搜索

    // 创建防抖函数实例
    this.debouncedCheckRegister = debounce((value) => {
      console.log("debouncedCheckRegister value :>> ", value)
      this.getPlaceList(value)
    }, 300)
  },
}
</script>

<style scoped>
.product-detail {
  /* padding-bottom: 80px; */
}

/* 自定义按钮样式 */
::v-deep .van-button--default {
  background-color: #f5f5f5;
  border-color: #e5e5e5;
  color: #666;
}

::v-deep .van-button--primary {
  background-color: #ff7a00;
  border-color: #ff7a00;
}

::v-deep .van-stepper {
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
}
::v-deep .van-stepper {
  border: 0;
}
/deep/.van-popup {
  background: transparent;
}
/deep/.home-popup {
  left: 0;
  right: 0;
  /* width: 100%; */
  margin-inline: auto;
  /* padding-inline: 1rem; */
}
/deep/.van-overlay {
  display: none;
}
/deep/.van-search {
  background-color: transparent;
}
/deep/.van-search__content {
  background-color: transparent;
  padding-left: 0;
}
/deep/.van-field__left-icon {
  display: none;
}
</style>
